module.exports = __webpack_public_path__ + "assets/img/buy_xuele_course1.c7e6b0b3.png";